import { Component, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ldc-iframe-grid',
  templateUrl: './iframe-grid.component.html',
  styleUrl: './iframe-grid.component.scss'
})
export class IframeGridComponent {
  @Input() iframes: SafeResourceUrl[] = [];
}
